import React from 'react'
import JdAudioAI from '../Pages/PostJob/JdAudioAI'

function PostJobAiVoice() {
  return (
    <>
        <JdAudioAI />
    </>
  )
}

export default PostJobAiVoice
